import { takeLatest, call, put } from 'redux-saga/effects';

import authService from 'services/authService';

import { getErrorMessage } from 'utils/stringUtils';

import { types, discover, sso } from './actions';

export function* watchSSODiscover(action) {
  const { email } = action.payload;
  try {
    // get the SSO URL from the discover endpoint
    const ssoConfig = yield call(authService.discoverSSO, email);
    try {
      // redirect to the SSO URL
      window.location.replace(ssoConfig.ssoUrl);
    } catch (error) {
      yield put(sso.error(getErrorMessage(error, 'Unknown error')));
    }
  } catch (error) {
    yield put(discover.error());
  }
}

export default function* root() {
  yield takeLatest(types.SSO_DISCOVER_REQUEST, watchSSODiscover);
}
